import { useState, useEffect } from 'react';

const navLinks = [
  { label: '사업개요', href: '#overview' },
  { label: '브랜드', href: '#brand' },
  { label: '입지환경', href: '#environment' },
  { label: '프리미엄', href: '#premium' },
  { label: '단지안내', href: '#complex' },
  { label: '세대안내', href: '#unit' },
  { label: '오시는길', href: '#location' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    setMobileOpen(false);
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md shadow-lg'
            : 'bg-transparent'
        }`}
      >
        <div className="flex items-center justify-between section-padding h-16 md:h-20">
          <a
            href="#top"
            onClick={(e) => handleNavClick(e, '#top')}
            className="flex flex-col items-start shrink-0 cursor-pointer"
          >
            <span className="font-display text-lg md:text-xl font-semibold tracking-wider transition-colors duration-300 text-primary-500">
              AUVERSONE
            </span>
            <span className="text-[10px] md:text-xs tracking-widest transition-colors duration-300 text-foreground-400">
              헤이리 오베르원
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors duration-300 rounded-md hover:bg-background-200/50 cursor-pointer text-foreground-200 hover:text-foreground-50"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="#register"
              onClick={(e) => handleNavClick(e, '#register')}
              className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-full border transition-all duration-300 whitespace-nowrap cursor-pointer border-primary-500/50 text-primary-400 hover:bg-primary-500/10 hover:text-primary-300"
            >
              <i className="ri-user-add-line" />
              관심고객등록
            </a>
            <a
              href="tel:031-945-0148"
              className="flex items-center gap-2 text-sm font-medium whitespace-nowrap transition-colors duration-300 cursor-pointer text-foreground-200 hover:text-primary-400"
            >
              <i className="ri-phone-line" />
              <span className="font-display text-base">031-945-0148</span>
            </a>
          </div>

          <button
            aria-label="메뉴 열기"
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden p-2 rounded-md transition-colors cursor-pointer"
          >
            <i className={`ri-menu-3-line text-xl ${scrolled ? 'text-foreground-50' : 'text-foreground-50'}`} />
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="lg:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/30">
            <div className="section-padding py-4 flex flex-col gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="px-3 py-2.5 text-sm font-medium rounded-md hover:bg-background-200/50 text-foreground-200 hover:text-foreground-50 transition-colors"
                >
                  {link.label}
                </a>
              ))}
              <div className="flex items-center gap-3 mt-3 pt-3 border-t border-background-200/30">
                <a
                  href="#register"
                  onClick={(e) => handleNavClick(e, '#register')}
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-full border border-primary-500/50 text-primary-400 hover:bg-primary-500/10 transition-colors"
                >
                  <i className="ri-user-add-line" />
                  관심고객등록
                </a>
                <a
                  href="tel:031-945-0148"
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors"
                >
                  <i className="ri-phone-line" />
                  031-945-0148
                </a>
              </div>
            </div>
          </div>
        )}
      </header>
    </>
  );
}